/**
 * iView Admin Pro 业务配置
 * */

const env = process.env.NODE_ENV;

const Setting = {
  // 接口请求地址
  apiBaseURL: env === 'development' ? 'https://h5.hypinxue.cn/' : 'https://h5.hypinxue.cn/',
};

export default Setting;



// WEBPACK FOOTER //
// ./src/setting.js